module.exports = __webpack_public_path__ + "static/img/48.c0476bbf.png";